import React, { useState } from 'react'
import { Button, Card, Col, Divider, Flex, Image, Input, Row, Typography, Badge, Popover } from 'antd'
import { ClockCircleOutlined, EnvironmentOutlined, FileImageOutlined, PaperClipOutlined, PlusCircleOutlined, SearchOutlined, SendOutlined, VideoCameraOutlined } from '@ant-design/icons'
import './index.css'

const { Text, Title, Paragraph } = Typography
const MessageBox = () => {
    

    const data = [
        {
            img:'av-1.png',
            title:'HospiceCare',
            desc:'Hey! Did you finish the Hi-FI wireframes for flora app design?',
            duration:'Today',
            time:'05:20 PM',
            counter:3,
        },
        {
            img:'av-1.png',
            title:'Ammi Watts',
            desc:'Hey! Did you finish the Hi-FI wireframes for flora app design?',
            duration:'Today',
            time:'05:20 PM',
            counter:2,
        },
        {
            img:'av-1.png',
            title:'Jerry Helfer',
            desc:'Hey! Did you finish the Hi-FI wireframes for flora app design?',
            duration:'Today',
            time:'05:20 PM',
            counter:6,
        },
        {
            img:'av-1.png',
            title:'David Elson',
            desc:'Hey! Did you finish the Hi-FI wireframes for flora app design?',
            duration:'Today',
            time:'05:20 PM',
            counter:4,
        },
        
    ]

  return (
    <Card className='p-0 pad-0-card border0 radius-12 shadow-c'>
        <Row>
            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                <div className='leftSideBox'>
                    <Flex vertical gap={'small'} className='w-100'>
                        <Typography.Title level={5} className='m-0 px-3 py-3'>
                            All Messages 
                        </Typography.Title>
                        <Divider className='m-0 divder-color' />
                        <div className='px-3 py-2'>
                            <Input className='w-100' placeholder="Search" prefix={<SearchOutlined />} />
                        </div>
                        <Divider className='m-0 divder-color' />
                        <div className='overflow-left over-w-0'>
                            {
                                data?.map((msg,m)=>
                                    <Flex gap={15} className='hovereffect py-3 px-3' key={m}>
                                        <div>
                                            <img src={"/assets/images/"+msg?.img} width={'50px'} height={'50px'} className='radius-12' alt="" />
                                        </div>
                                        <Flex vertical gap={2}>
                                            <Flex justify='space-between'>
                                                <Text strong className='m-0'>
                                                    {
                                                        msg?.title
                                                    }
                                                </Text>
                                                <Badge style={{background: 'var(--brand-color)'}} count={msg?.counter}></Badge>
                                            </Flex>
                                            <Paragraph 
                                                className='grayish fs-12'
                                                ellipsis={{
                                                    rows: 1,
                                                }}
                                                title={msg?.desc}
                                                style={{width:200}}
                                            >
                                                {
                                                    msg?.desc
                                                }
                                            </Paragraph>
                                            {/* <Flex gap={5} className='w-100 py-1' align='center'>
                                                <ClockCircleOutlined />
                                                <Typography.Text className='grayish fs-12'>
                                                    {
                                                        msg?.duration
                                                    }
                                                </Typography.Text>
                                                <Divider type="vertical" />
                                                <Typography.Text className='grayish fs-12'>
                                                    {
                                                        msg?.time
                                                    }
                                                </Typography.Text>
                                            </Flex> */}
                                        </Flex>
                                    </Flex>
                                )
                            }
                        </div>
                    </Flex>
                </div>
            </Col>
            <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                <div className='rightSideBox'>
                    <Flex gap={15} className='pad-12-5' align='center'>
                        <div>
                            <Image src="/assets/images/av-1.png" width={'40px'} height={'40px'} preview={false} className='radius-12' alt="" />
                        </div>
                        <Typography.Title level={5} className='m-0 grayish'>
                            Ammi Watts
                        </Typography.Title>
                    </Flex>
                    <Divider className='m-0 divder-color' />
                    <div className='overflow-right over-w-0'>
                        {/* <Flex gap={5} className='w-100 py-3' align='center' justify='center'>
                            <Typography.Text className='grayish fs-12'>
                                Today
                            </Typography.Text>
                            <Divider type="vertical" />
                            <Typography.Text className='grayish fs-12'>
                                05:20 PM
                            </Typography.Text>
                        </Flex> */}
                        <Flex vertical gap={'large'}>
                            <Flex vertical gap={5} className='w-fitcontent'>
                                <div className='incomingMsg common-cs'>
                                    <Text className='fs-13'>
                                        Oh, hello! All perfectly. I will check it and get back to you soon
                                    </Text>
                                </div>
                                <Text className='grayish fs-12'>
                                    05:20 PM
                                </Text>
                            </Flex>
                            <Flex vertical gap={5} className='w-fitcontent mar-left-auto' justify='end'>
                                <div className='outgoing common-cs'>
                                    <Text className='fs-13 text-white'>
                                        Oh, hello! All perfectly. I will check it and get back to you soon
                                    </Text>
                                </div>
                                <Text className='grayish fs-12'>
                                    05:20 PM
                                </Text>
                            </Flex>
                        </Flex>
                        <Flex vertical gap={'large'}>
                            <Flex vertical gap={5} className='w-fitcontent'>
                                <div className='incomingMsg common-cs'>
                                    <Text className='fs-13'>
                                        Oh, hello! All perfectly. I will check it and get back to you soon
                                    </Text>
                                </div>
                                <Text className='grayish fs-12'>
                                    05:20 PM
                                </Text>
                            </Flex>
                            <Flex vertical gap={5} className='w-fitcontent mar-left-auto' justify='end'>
                                <div className='outgoing common-cs'>
                                    <Text className='fs-13 text-white'>
                                        Oh, hello! All perfectly. I will check it and get back to you soon
                                    </Text>
                                </div>
                                <Text className='grayish fs-12'>
                                    05:20 PM
                                </Text>
                            </Flex>
                        </Flex>
                    </div>
                    <Divider className='m-0 divder-color' />
                    <Flex gap={'small'} className='pt-3' style={{position:'relative'}}>
                        <Button type='link' ghost className='grayish'>
                            <PaperClipOutlined style={{fontSize:20}}/>
                        </Button>
                        <Input placeholder='Type your message here...' suffix={<SendOutlined />} />
                        {/* <Popover
                            content={
                                <Flex vertical> 
                                    <Button type="link" className='brand-color'>
                                        <FileImageOutlined />
                                    </Button>
                                    <Button type="link" className='brand-color'>
                                        <VideoCameraOutlined />
                                    </Button>
                                    <Button type="link" className='brand-color'>
                                        <EnvironmentOutlined />
                                    </Button>
                                </Flex>
                            }
                            trigger="click"
                            open={open}
                            onOpenChange={handleOpenChange}
                            >
                            <Button type="link" className='grayish'>
                                <PlusCircleOutlined style={{fontSize:20}} />
                            </Button>
                        </Popover> */}
                    </Flex>
                </div>
            </Col>
        </Row>
    </Card>
  )
}

export {MessageBox}